import { SubTypeOption } from "../api/gms/group-category/group-category-api-state";
import { InputOptionGDR } from "../features/gms-proposal-forms/attachable-rider/attachable-riders.state";
import { Option } from "../features/it-user-forms/user-form-state";
import { v4 as uuidv4 } from "uuid";

export const options: Option[] = [
  { id: 1, value: "group_name", name: "Group Name" },
  { id: 2, value: "email", name: "Email" },
  { id: 3, value: "product", name: "Product" },
  { id: 4, value: "preparedBy", name: "Prepared by" },
  { id: 5, value: "status", name: "Status" },
];

export const optionsUsers: Option[] = [
  { id: 1, value: "name", name: "Name" },
  { id: 2, value: "email", name: "Email" },
  { id: 3, value: "department", name: "Department" },
  { id: 4, value: "role", name: "Role" },
];

export const optionForGroupDengueRider: InputOptionGDR[] = [
  { id: 1, label: "30,000.00 (1 Unit)", fAmount: 30000 },
  { id: 2, label: "60,000.00 (2 Unit)", fAmount: 60000  },
]

export const channelType: SubTypeOption[] = [
  { id: 1, name: "Direct" },
  { id: 2, name: "Booker" },
  { id: 3, name: "General Agency" }
];